/**
 * Версія контракту: API кладе її в SolverProblem.contractVersion, солвер відхиляє несумісну (major).
 * 1.1: SolverTravel.teacherMinutes (D43), SolverUnit.halfParity (D10), SolverFixed.subjectId, SolverProblem.semesterStart.
 */
export const SOLVER_CONTRACT_VERSION = '1.1';
/** Ваги за замовчуванням (SPEC 7.4). Жорсткі критерії ТЗ §15 — 10000 (лише Quality Score / allowHardViolations). */
export const DEFAULT_SOLVER_WEIGHTS = {
    studentWindow: 100,
    teacherWindow: 60,
    transition: 80,
    transitionMinutes: 1,
    dayUnevenness: 50,
    latePair: 30,
    teacherUndesired: 20,
    teacherPreferredMissed: 10,
    sameBuildingDay: 20,
    roomCapacityWaste: 1,
    hintDeviation: 40,
    unplaced: 10000,
    resourceConflict: 10000,
    teacherUnavailable: 10000,
    capacityExceeded: 10000,
};
/** Ключі ваг у порядку показу. */
export const SOLVER_WEIGHT_KEYS = Object.keys(DEFAULT_SOLVER_WEIGHTS);
/** Підписи ваг для сторінки «Профілі ваг». */
export const SOLVER_WEIGHT_LABELS = {
    studentWindow: '«Вікно» у студентів',
    teacherWindow: '«Вікно» у викладачів',
    transition: 'Перехід між корпусами',
    transitionMinutes: 'Хвилина переходу',
    dayUnevenness: 'Нерівномірність навантаження по днях',
    latePair: 'Пізня пара',
    teacherUndesired: 'Небажаний час викладача',
    teacherPreferredMissed: 'Невиконане побажання викладача',
    sameBuildingDay: 'Різні корпуси протягом дня',
    roomCapacityWaste: 'Зайві місця в аудиторії (за 10 місць)',
    hintDeviation: 'Відхилення від поточного розкладу',
    unplaced: 'Нерозміщене заняття',
    resourceConflict: 'Конфлікт ресурсів',
    teacherUnavailable: 'Недоступний викладач',
    capacityExceeded: 'Перевищення місткості',
};
/** Правила за замовчуванням, якщо в SchedulingRule немає свого значення. */
export const DEFAULT_SOLVER_RULES = {
    maxPairsPerDayStudent: 4,
    maxConsecutivePairs: 4,
    lateSlotFromIndex: 5,
    sameSubjectOncePerDay: true,
};
const w = (overrides) => ({ ...DEFAULT_SOLVER_WEIGHTS, ...overrides });
/** Системні профілі ваг (D16, ТЗ §45) — сід WeightProfile (isSystem = true). */
export const SYSTEM_WEIGHT_PROFILES = [
    {
        code: 'MIN_WINDOWS',
        name: 'Мінімум вікон',
        description: 'Варіант А: компактні дні для студентів і викладачів.',
        isDefault: false,
        weights: w({ studentWindow: 300, teacherWindow: 180, dayUnevenness: 30 }),
    },
    {
        code: 'MIN_TRANSITIONS',
        name: 'Мінімум переміщень',
        description: 'Варіант Б: менше переходів між корпусами і клінічними базами.',
        isDefault: false,
        weights: w({ transition: 300, transitionMinutes: 4, sameBuildingDay: 80 }),
    },
    {
        code: 'ROOM_EFFICIENCY',
        name: 'Ефективність аудиторій',
        description: 'Варіант В: аудиторії найменшої достатньої місткості.',
        isDefault: false,
        weights: w({ roomCapacityWaste: 8, sameBuildingDay: 10 }),
    },
    {
        code: 'BALANCED',
        name: 'Збалансований',
        description: 'Варіант Г: ваги за замовчуванням (SPEC 7.4).',
        isDefault: true,
        weights: w({}),
    },
];
export const SOLVER_STATUS_LABELS = {
    OPTIMAL: 'Оптимальний розв’язок',
    FEASIBLE: 'Допустимий розв’язок',
    INFEASIBLE: 'Розв’язку не існує',
    TIMEOUT_NO_SOLUTION: 'Час вичерпано без розв’язку',
};
export const SOLVER_JOB_STATUS_LABELS = {
    QUEUED: 'У черзі',
    RUNNING: 'Виконується',
    DONE: 'Завершено',
    FAILED: 'Помилка',
    CANCELLED: 'Скасовано',
};
export const SOLVER_PHASE_LABELS = {
    PREPARE: 'Підготовка',
    PLACEMENT: 'Розміщення',
    ROOMS: 'Аудиторії',
    IMPROVE: 'Покращення',
    DONE: 'Завершено',
};
export const UNPLACED_REASON_LABELS = {
    NO_FEASIBLE_SLOT: 'Немає допустимого часу',
    NO_ROOM: 'Немає відповідної вільної аудиторії',
    TEACHER_UNAVAILABLE: 'Викладач недоступний',
    AUDIENCE_BUSY: 'Контингент зайнятий',
    TRAVEL_TIME: 'Недостатньо часу на переміщення',
    DEPARTMENT_CAPACITY: 'Вичерпано місткість кафедри для циклів',
    WINDOW_TOO_SHORT: 'Вікно дат циклу закоротке',
    TIMEOUT: 'Вичерпано ліміт часу',
    INFEASIBLE_MODEL: 'Суперечливі обмеження',
    OTHER: 'Інша причина',
};
//# sourceMappingURL=defaults.js.map